/**
 * Content Hub Related Categories Entry Point
 * @main
 */

 import React from 'react';
 import { render } from 'react-dom';
 import RelatedArticles from './components/related-articles.jsx';
 
 // render main locator component
 const root = document.getElementById('c-h-category-related-articles');
 render(<RelatedArticles datasourceId={root.dataset['datasource']}/>, root);